import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import sendRequest from '../../service/sendRequest';
import { confirmAccess } from './demoRecreateReducer';
import { enqueueSnackbar, somethingWrongNotification } from '../notifier/notifierActions';
import passwordGenerator from '../../utils/passwordGeneration';
import { imageCache, setInCache } from '../../utils/clearId8ImageCaches';

const DEMO_CONFIRM_AD_IMAGES_PASSWORD = 'demoRecreate/DEMO_CONFIRM_AD_IMAGES_PASSWORD';
const DEMO_RECREATE_AD = 'demoRecreate/DEMO_RECREATE_AD';

export const confirmAdImagesPassword = createAsyncThunk(
  DEMO_CONFIRM_AD_IMAGES_PASSWORD,
  async ({ password }, { dispatch, rejectWithValue }) => {
    const response = await sendRequest(() => axios.post(`/api/consumer/id8/demo/recreate/login?password=${password}`), {
      onError: (e) => demoRequestErrorHandler(e, dispatch, rejectWithValue),
    });

    dispatch(confirmAccess({ password, attempts: response.data }));
  },
);

export const recreateAdDemo = createAsyncThunk(
  DEMO_RECREATE_AD,
  async ({ image, description, url }, { getState, dispatch, rejectWithValue }) => {
    const password = getState().demoRecreate.password;
    const formData = new FormData();
    formData.append('file', image, image.name);

    const response = await sendRequest(
      () =>
        axios.request({
          url: `/api/consumer/id8/demo/recreate/generate?url=${url}&password=${password}&description=${description}`,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          method: 'POST',
          data: formData,
        }),
      {
        onError: (e) => demoRequestErrorHandler(e, dispatch, rejectWithValue),
      },
    );

    const sourceImageKey = passwordGenerator();
    const blobUrl = URL.createObjectURL(new Blob([image]));
    setInCache(imageCache, sourceImageKey, blobUrl);

    return { content: response.data, sourceImageKey };
  },
);

const demoRequestErrorHandler = (e, dispatch, rejectWithValue) => {
  if (e.response.status === 409 || e.response.status === 402) {
    dispatch(
      enqueueSnackbar({
        message: e.response.data,
        options: {
          variant: 'error',
        },
      }),
    );
    return rejectWithValue(e);
  }

  if (e.response.status === 401) {
    dispatch(
      enqueueSnackbar({
        message: 'invalidCredentials',
        options: {
          variant: 'error',
        },
      }),
    );
    return rejectWithValue(e);
  }

  dispatch(somethingWrongNotification());
  return rejectWithValue(e);
};
